import { InternalNetworkAssetsContract } from '@terra/shared-contracts-internal-network';
import { createTerraOrpcClient } from '@terra/shared-utils';

export const internalNetworkAssetsClient = createTerraOrpcClient({
  contract: InternalNetworkAssetsContract,
  serviceName: 'orchestrator',
});
